var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkTree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 207.136,
    height: 394.66,
    viewBox: "0 0 207.136 394.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.57,225.762l.162,24.708H83.947V225.762Z",
    transform: "translate(35.492 144.19)",
    fill: "#736357"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.567,0,57.15,101.831H74.715L43.6,170.093H63.964l-40.5,88.852H50.6L0,369.952H103.567Z",
    transform: "translate(0)",
    fill: "#086945"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2,0V369.952H166.769l-50.6-111.006h27.135l-40.5-88.852h20.366L92.055,101.831h17.562Z",
    transform: "translate(40.366)",
    fill: "#09603f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkTree);
export default __webpack_public_path__ + "static/media/dark-tree.fe79099e6f33bd52d1cc9ce39f1a2324.svg";
export { ForwardRef as ReactComponent };